(function(){
  // Concept 4 — Card-based hamburger menu for MasalSensin
  // Dwell renders a default menu drawer; we hide its navigation and inject a custom
  // card layout in its place. CSS lives in masalsensin-custom.css (.ms-c4-* classes).

  function getHTML(){
    var html = '';
    html += '<div class="ms-c4-drawer">';

    // Brand header
    html += '<a href="/" class="ms-c4-header" data-ms-home-link>';
    html +=   '<div class="ms-c4-brand">MasalSensin</div>';
    html +=   '<div class="ms-c4-sub">Çocuğunun masalı ✨</div>';
    html += '</a>';

    // Hero
    html += '<a class="ms-c4-card ms-c4-card--hero" href="/pages/hediye-secici">';
    html +=   '<span class="ms-c4-card-icon">🎁</span>';
    html +=   '<div class="ms-c4-card-text">';
    html +=     '<div class="ms-c4-card-title">Masal Bul</div>';
    html +=     '<div class="ms-c4-card-meta">3 soruda doğru kitabı bul</div>';
    html +=   '</div>';
    html +=   '<span class="ms-c4-card-chev">›</span>';
    html += '</a>';

    // Yaş cards
    html += '<div class="ms-c4-sec-label">Yaşa Göre</div>';
    html += '<a class="ms-c4-card ms-c4-card--flat" href="/collections/bebek-masallari-1-3-yas">';
    html +=   '<span class="ms-c4-card-icon"><img src="https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/menu-thumb-bebek.png?v=1777705210" alt="Bebek" loading="lazy" width="44" height="44"></span>';
    html +=   '<div class="ms-c4-card-text"><div class="ms-c4-card-title">Bebek</div><div class="ms-c4-card-meta">1-3 yaş için yumuşak hikayeler</div></div>';
    html +=   '<span class="ms-c4-card-chev">›</span>';
    html += '</a>';
    html += '<a class="ms-c4-card ms-c4-card--flat" href="/collections/okul-oncesi-3-6-yas">';
    html +=   '<span class="ms-c4-card-icon"><img src="https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/menu-thumb-okul-oncesi.png?v=1777705211" alt="Okul Öncesi" loading="lazy" width="44" height="44"></span>';
    html +=   '<div class="ms-c4-card-text"><div class="ms-c4-card-title">Okul Öncesi</div><div class="ms-c4-card-meta">3-6 yaş için keşif kitapları</div></div>';
    html +=   '<span class="ms-c4-card-chev">›</span>';
    html += '</a>';
    html += '<a class="ms-c4-card ms-c4-card--flat" href="/collections/ilkokul-6-10-yas">';
    html +=   '<span class="ms-c4-card-icon"><img src="https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/menu-thumb-ilkokul.png?v=1777705212" alt="İlkokul" loading="lazy" width="44" height="44"></span>';
    html +=   '<div class="ms-c4-card-text"><div class="ms-c4-card-title">İlkokul</div><div class="ms-c4-card-meta">6-10 yaş için maceralar</div></div>';
    html +=   '<span class="ms-c4-card-chev">›</span>';
    html += '</a>';

    // Tema cards
    html += '<div class="ms-c4-sec-label">Konuya Göre</div>';
    html += '<a class="ms-c4-card ms-c4-card--flat" href="/collections/super-kahraman">';
    html +=   '<span class="ms-c4-card-icon"><img src="https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/menu-thumb-super-kahraman.png?v=1777705213" alt="Süper Kahraman" loading="lazy" width="44" height="44"></span>';
    html +=   '<div class="ms-c4-card-text"><div class="ms-c4-card-title">Süper Kahraman</div><div class="ms-c4-card-meta">Cesaret ve süper güçler</div></div>';
    html +=   '<span class="ms-c4-card-chev">›</span>';
    html += '</a>';
    html += '<a class="ms-c4-card ms-c4-card--flat" href="/collections/hayvan-dostum">';
    html +=   '<span class="ms-c4-card-icon"><img src="https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/menu-thumb-hayvan-dostum.png?v=1777705214" alt="Hayvan Dostum" loading="lazy" width="44" height="44"></span>';
    html +=   '<div class="ms-c4-card-text"><div class="ms-c4-card-title">Hayvan Dostum</div><div class="ms-c4-card-meta">Hayvanlarla dostluk maceraları</div></div>';
    html +=   '<span class="ms-c4-card-chev">›</span>';
    html += '</a>';
    html += '<a class="ms-c4-card ms-c4-card--flat" href="/collections/gunluk-degerler-egitimi">';
    html +=   '<span class="ms-c4-card-icon"><img src="https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/menu-thumb-gunluk-degerler.png?v=1777705215" alt="Günlük Değerler" loading="lazy" width="44" height="44"></span>';
    html +=   '<div class="ms-c4-card-text"><div class="ms-c4-card-title">Günlük Değerler</div><div class="ms-c4-card-meta">Paylaşma, sabır, dürüstlük</div></div>';
    html +=   '<span class="ms-c4-card-chev">›</span>';
    html += '</a>';
    html += '<a class="ms-c4-card ms-c4-card--flat" href="/collections/duygu-kontrolleri">';
    html +=   '<span class="ms-c4-card-icon"><img src="https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/menu-thumb-duygu-kontrolleri.png?v=1777705216" alt="Duygu Kontrolleri" loading="lazy" width="44" height="44"></span>';
    html +=   '<div class="ms-c4-card-text"><div class="ms-c4-card-title">Duygu Kontrolleri</div><div class="ms-c4-card-meta">Öfke, korku, sevgiyi anlama</div></div>';
    html +=   '<span class="ms-c4-card-chev">›</span>';
    html += '</a>';
    html += '<a class="ms-c4-card ms-c4-card--flat" href="/collections/meslek-hikayeleri">';
    html +=   '<span class="ms-c4-card-icon"><img src="https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/menu-thumb-meslek-hikayeleri.png?v=1777705217" alt="Meslek Hikayeleri" loading="lazy" width="44" height="44"></span>';
    html +=   '<div class="ms-c4-card-text"><div class="ms-c4-card-title">Meslek Hikayeleri</div><div class="ms-c4-card-meta">Hayalindeki meslekleri keşfet</div></div>';
    html +=   '<span class="ms-c4-card-chev">›</span>';
    html += '</a>';

    // Tarz cards
    html += '<div class="ms-c4-sec-label">Tarza Göre</div>';
    html += '<a class="ms-c4-card ms-c4-card--flat" href="/collections/hikaye-kitaplari">';
    html +=   '<span class="ms-c4-card-icon"><img src="https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/menu-thumb-hikaye-kitaplari.png?v=1777705218" alt="Hikaye Kitapları" loading="lazy" width="44" height="44"></span>';
    html +=   '<div class="ms-c4-card-text"><div class="ms-c4-card-title">Hikaye Kitapları</div><div class="ms-c4-card-meta">Kişiselleştirilmiş masallar</div></div>';
    html +=   '<span class="ms-c4-card-chev">›</span>';
    html += '</a>';
    html += '<a class="ms-c4-card ms-c4-card--flat" href="/collections/boyama-kitaplari">';
    html +=   '<span class="ms-c4-card-icon"><img src="https://cdn.shopify.com/s/files/1/0814/5669/3473/t/7/assets/menu-thumb-boyama-kitaplari.png?v=1777705219" alt="Boyama Kitapları" loading="lazy" width="44" height="44"></span>';
    html +=   '<div class="ms-c4-card-text"><div class="ms-c4-card-title">Boyama Kitapları</div><div class="ms-c4-card-meta">Çocuk için boyama</div></div>';
    html +=   '<span class="ms-c4-card-chev">›</span>';
    html += '</a>';

    // Hesap & Bilgi (compact list — different from cards on purpose, less visual weight)
    html += '<div class="ms-c4-sec-label">Hesap &amp; Bilgi</div>';
    html += '<div class="ms-c4-list">';
    html +=   '<a class="ms-c4-list-row" href="/cart"><span class="ms-c4-list-ico">🛒</span><span class="ms-c4-list-txt">Sepetim</span><span class="ms-c4-list-chev">›</span></a>';
    html +=   '<a class="ms-c4-list-row" href="/account"><span class="ms-c4-list-ico">👤</span><span class="ms-c4-list-txt">Hesabım &amp; Siparişlerim</span><span class="ms-c4-list-chev">›</span></a>';
    html +=   '<a class="ms-c4-list-row" href="/pages/nasil-calisir"><span class="ms-c4-list-ico">❓</span><span class="ms-c4-list-txt">Nasıl Çalışır?</span><span class="ms-c4-list-chev">›</span></a>';
    html +=   '<a class="ms-c4-list-row" href="/pages/sss"><span class="ms-c4-list-ico">💬</span><span class="ms-c4-list-txt">Sıkça Sorulan Sorular</span><span class="ms-c4-list-chev">›</span></a>';
    html +=   '<a class="ms-c4-list-row" href="/pages/hakkimizda"><span class="ms-c4-list-ico">ℹ️</span><span class="ms-c4-list-txt">Hakkımızda</span><span class="ms-c4-list-chev">›</span></a>';
    html +=   '<a class="ms-c4-list-row" href="/pages/contact"><span class="ms-c4-list-ico">📞</span><span class="ms-c4-list-txt">İletişim</span><span class="ms-c4-list-chev">›</span></a>';
    html +=   '<a class="ms-c4-list-row" href="https://wa.me/905555555555" target="_blank" rel="noopener"><span class="ms-c4-list-ico">✉️</span><span class="ms-c4-list-txt">WhatsApp Destek</span><span class="ms-c4-list-chev">›</span></a>';
    html += '</div>';

    // Trust badges
    html += '<div class="ms-c4-trust-row">';
    html +=   '<span class="ms-c4-trust"><span class="ms-c4-trust-ico">🚚</span><span class="ms-c4-trust-lbl">Ücretsiz Kargo</span></span>';
    html +=   '<span class="ms-c4-trust"><span class="ms-c4-trust-ico">🎁</span><span class="ms-c4-trust-lbl">Hediye Paketi</span></span>';
    html +=   '<span class="ms-c4-trust"><span class="ms-c4-trust-ico">🛡️</span><span class="ms-c4-trust-lbl">Güvenli Ödeme</span></span>';
    html += '</div>';

    html += '</div>';
    
    return html;
  }

  function inject(){
    var drawers = document.querySelectorAll(".menu-drawer");
    for (var i = 0; i < drawers.length; i++) {
      var d = drawers[i];
      if (d.querySelector("#ms-custom-nav")) return;
      var nav = d.querySelector(".menu-drawer__navigation");
      if (!nav) continue;
      nav.style.display = "none";
      var div = document.createElement("div");
      div.id = "ms-custom-nav";
      div.innerHTML = getHTML();
      d.insertBefore(div, nav);
      return;
    }
  }

  new MutationObserver(function(){ inject(); }).observe(document.documentElement, { childList: true, subtree: true, attributes: true });
  inject();

  // "Nasıl Çalışır?" link — scroll to the .ms-how-it-works section on the homepage.
  // If target exists on current page → smooth scroll + close drawer.
  // Otherwise the browser navigates to /#nasil-calisir and the on-load handler below picks it up.
  window.msToggleExpand = function(card){
    if (!card) return;
    card.classList.toggle('ms-c4-card--open');
  };

  window.msMenuScrollHow = function(e){
    var target = document.querySelector('.ms-how-it-works, [class*="ms_how_it_works"], [id$="__ms_how_it_works"]');
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Close Dwell drawer
      var det = document.querySelector('#Details-menu-drawer-container, details[id*=menu-drawer]');
      if (det) det.removeAttribute('open');
    }
    // If target missing, let the link navigate to /#nasil-calisir normally.
  };

  // On homepage load with #nasil-calisir hash, auto-scroll to the section.
  // Runs once when DOM is ready.
  function handleHashScroll() {
    if (location.hash === '#nasil-calisir' || location.hash === '#how-it-works') {
      var tries = 0;
      var poll = setInterval(function(){
        var target = document.querySelector('.ms-how-it-works, [class*="ms_how_it_works"], [id$="__ms_how_it_works"]');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          clearInterval(poll);
        } else if (++tries > 20) {
          clearInterval(poll);
        }
      }, 150);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleHashScroll);
  } else {
    handleHashScroll();
  }
})();
